// Services
import petsService from "@/app/services/main/pets/pets-service";
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins.js";

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

// Components
const ProductPurchaseListingContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "product-purchase-listing-container" */ "@/app/views/main-view/purchases/containers/product-purchase/product-purchase-listing-container/product-purchase-listing-container.vue"
    );

const SubscriptionListingContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "subscription-listing-container" */ "@/app/views/main-view/purchases/containers/subscription/subscription-listing-container/subscription-listing-container.vue"
    );

const PuppyPurchaseListingContainer = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "puppy-purchase-listing-container" */ "@/app/views/main-view/purchases/containers/puppy-purchase/puppy-purchase-listing-container/puppy-purchase-listing-container.vue"
    );

export default {
    name: "PurchasesContainer",
    components: {
        ProductPurchaseListingContainer,
        SubscriptionListingContainer,
        PuppyPurchaseListingContainer,
    },
    mixins: [inputTextMixins, toastMessageMixins, userMixins, shoppingMixins],
    data() {
        return {
            requestList: [],
            puppyPurchasedList: [],
            page: 1,
            limitFilter: 8,
            increment: 8,
            activeTabId: "",
            productPendingCount: 1,
            isOnDetailsPageView: false,
            tabs: [
                {
                    label: "Product Purchase",
                    id: "orders",
                    active: true,
                },
                {
                    label: "Subscriptions",
                    id: "subscriptions",
                    active: false,
                },
                {
                    label: "Puppy Purchase",
                    id: "puppies",
                    active: false,
                },
            ],
        };
    },
    created() {
        this.checkAvailablePurchases();
    },
    watch: {
        $route: {
            immediate: true,
            handler(url) {
                const { path } = url;

                if (!path) {
                    return;
                }

                // the usage of this is to when the user uses the navigation buttons in the browser
                // ex. /purchases/subscriptions
                const pathSplit = path.split("/");
                
                if (pathSplit.length > 2) {
                    // we are getting the ids like "subscription", "puppies", or "orders"
                    const selectedTabId = path.split("/")[2];

                    this.tabs = this.tabs.map((tab) => {
                        // set the selected tab to active
                        tab.active = tab.id === selectedTabId;
                        return tab;
                    });

                    this.activeTabId = selectedTabId;
                }

                // the usage of this is to display/hide the tabs in the Purchases header
                if (path && path.toLowerCase().includes("view")) {
                    this.isOnDetailsPageView = true;
                } else {
                    this.isOnDetailsPageView = false;
                }
            },
        },
    },
    computed: {
        getActiveTab() {
            return this.tabs.find((tab) => tab.active);
        },
    },
    methods: {
        async checkAvailablePurchases() {
            let queryParams = {
                page: this.page,
                limit: this.increment,
                f_userId: this.userId,
                sortBy: "",
                desc: true,
            };

            let dogPurchasedCount, puppyPurchasedCount;

            const petResponse = await petsService.getPetPurchase(queryParams);
            const puppyResponse = await puppySellService.getPuppyPurchasedList(
                queryParams
            );

            petResponse.status === STATUS_CODES.SUCCESS
                ? (dogPurchasedCount = petResponse.data.data.length)
                : (dogPurchasedCount = 0);

            puppyResponse.status === STATUS_CODES.SUCCESS
                ? (puppyPurchasedCount = puppyResponse.data.data.length)
                : (puppyPurchasedCount = 0);
        },

        setActiveTab(selectedTabId) {
            if (this.activeTabId === selectedTabId) {
                return;
            }

            this.$router.push(`/purchases/${selectedTabId}`);
            this.activeTabId = selectedTabId;

            this.tabs = this.tabs.map((tab) => {
                // set the selected tab to active
                tab.active = tab.id === selectedTabId;
                return tab;
            });
        },
    },
};
